<template>
  <div class="field-list listable">
    <div class="listable-head">
      <div class="th">
        <span class="text">Label</span>
      </div>
      <div class="th">
        <span class="text">Field Type</span>
      </div>
      <div class="th">
        <span class="text">Required?</span>
      </div>
      <div class="th">
        <span class="text">Conditional?</span>
      </div>
    </div>
    <Draggable class="listable-sortables" v-model="assigned">
      <div v-for="(field, f) in assigned" :key="`field_${f}`" class="listable-data">
        <div class="td">{{ field.label }}</div>
        <div class="td">{{ fieldTypeLabel(field.type) }}</div>
        <div class="td">{{ !!field.is_required ? "Yes" : "No" }}</div>
        <div class="td">{{ !!field.is_conditional ? "Yes" : "No" }}</div>
        <div class="td text-right">
          <ContextMenu :id="`field_menu_${f}`" :items="fieldMenu(field, f)" align="right" />
        </div>
        <div class="d-none">
          <input type="hidden" :name="`fields[${f}][id]`" :value="field.id" />
          <input type="hidden" :name="`fields[${f}][group_id]`" :value="field.group_id || null" />
          <input type="hidden" :name="`fields[${f}][type]`" :value="field.type" />
          <input type="hidden" :name="`fields[${f}][label]`" :value="field.label" />
          <input type="hidden" :name="`fields[${f}][autofill]`" :value="field.autofill" />
           <template  v-if="field.type == 'html'">
            <div class="d-none">
                <textarea :name="`fields[${f}][value]`">{{field.value}}</textarea>
            </div>
           </template>
            <template v-else-if="typeof field.value === 'string' && field.value">
                <input type="hidden" :name="`fields[${f}][value]`" :value="field.value" />
            </template>
            <template v-else>
                <div v-for="(value, v) in field.value" :key="`field_${f}_value_${v}`">
                    <input
                        v-if="value != ''"
                        type="hidden"
                        :name="`fields[${f}][value][${v}]`"
                        :value="value"
                    />
                </div>
            </template>
          <input
            type="hidden"
            :name="`fields[${f}][is_required]`"
            :value="!!field.is_required ? 1 : 0"
          />
          <input
            type="hidden"
            :name="`fields[${f}][is_conditional]`"
            :value="!!field.is_conditional ? 1 : 0"
          />
          <input
            type="hidden"
            :name="`fields[${f}][conditional_visibility]`"
            :value="field.conditional_visibility"
          />
          <input
            type="hidden"
            :name="`fields[${f}][conditional_scope]`"
            :value="field.conditional_scope"
          />
          <div
            v-for="(condition, c) in field.conditions"
            :key="`field_${f}_condition_${c}`"
            class="d-none"
          >
            <input
              v-if="!!condition.target_id"
              type="hidden"
              :name="`fields[${f}][conditions][${c}][target_id]`"
              :value="condition.target_id"
            />
            <input
              v-if="!!condition.target_id"
              type="hidden"
              :name="`fields[${f}][conditions][${c}][operand]`"
              :value="condition.operand"
            />
            <input
              v-if="!!condition.target_id"
              type="hidden"
              :name="`fields[${f}][conditions][${c}][value]`"
              :value="condition.value"
            />
          </div>
        </div>
      </div>
    </Draggable>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
export default {
  components: { Draggable },
  props: {
    assigned: { type: Array, default: () => [] },
    fieldTypes: { type: Array, required: true }
  },
  methods: {
    fieldTypeLabel(fieldType) {
      return this.fieldTypes.find(type => type.value == fieldType).label;
    },
    fieldMenu(field, index) {
      return [
        {
          label: "Edit",
          action: () => {
            this.$emit("edit", _.cloneDeep(field));
          }
        },
        {
          label: "Remove",
          action: () => {
            this.$emit("remove", index);
          }
        }
      ];
    }
  }
};
</script>